import React, { useState, useEffect } from 'react';
import Login from './components/Login';
import AdminPanel from './components/AdminPanel';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [authToken, setAuthToken] = useState(null);

  // Check if user is already logged in when app loads
  useEffect(() => {
    const token = localStorage.getItem('authToken');
    const userEmail = localStorage.getItem('userEmail');
    
    if (token && userEmail) {
      // You can add token validation here if needed
      setAuthToken(token);
      setIsAuthenticated(true);
    }
    
    setIsLoading(false);
  }, []);

  // Handle successful login
  const handleLoginSuccess = (token, isNewUser) => {
    setAuthToken(token);
    setIsAuthenticated(true);
    
    // If it's a new user, you might want to redirect to account creation
    // For now, we'll just go to admin panel
  };

  // Handle logout
  const handleLogout = () => {
    localStorage.removeItem('authToken');
    localStorage.removeItem('userEmail');
    localStorage.removeItem('isNewUser');
    setAuthToken(null);
    setIsAuthenticated(false);
  };

  // Show loading spinner while checking authentication
  if (isLoading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  // Show login page if not authenticated
  if (!isAuthenticated) {
    return <Login onLoginSuccess={handleLoginSuccess} />;
  }

  // Show admin panel if authenticated
  return <AdminPanel authToken={authToken} onLogout={handleLogout} />;
}

export default App;